import { BASE_URL } from '../config';
import { transformCoordinates, generateInsertXML } from '../utils/XmlGenerators';
import { getAccessToken } from './LoginForm/Auth/auth';

export const handleSave = async (
  points,
  multiPoints,
  lines,
  multiLines,
  polygons,
  multiPolygons,
  attributeValues,
  layerCRS,
  layerName,
  setInputUrl,
  setRefresh,
  setCurrentDrawing,
  setPoints,
  setMultiPoints,
  setLines,
  setMultiLines,
  setPolygons,
  setMultiPolygons,
  setPopupInfo,
  setIsCreated
) => {

 // console.log("🚀 Zapoceto čuvanje podataka...");
 // console.log("🌍 CRS sloja:", layerCRS);
 // console.log("🗂 Naziv sloja:", layerName);
//  console.log("📌 Uneti atributi:", attributeValues);
  const token = getAccessToken();
  const features = [
    ...points.map(point => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: point.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: point.geometry_name
    })),
    ...multiPoints.map(multiPoint => ({
      type: 'Feature',
      geometry: {
        type: 'MultiPoint',
        coordinates: multiPoint.geometry.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: multiPoint.geometry_name
    })),
    ...lines.map(line => ({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: line.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: line.geometry_name
    })),
    ...multiLines.map(multiLine => ({
      type: 'Feature',
      geometry: {
        type: 'MultiLineString',
        coordinates: multiLine.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: multiLine.geometry_name
    })),
    ...polygons.map(polygon => ({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: polygon.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: polygon.geometry_name
    })),
    ...multiPolygons.map(multiPolygon => ({
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: multiPolygon.coordinates
      },
      properties: { ...attributeValues },
      geometry_name: multiPolygon.geometry_name
    }))
  ];

 // console.log("📌 Broj kreiranih feature-a:", features.length);
 // console.log("🗺 Originalni feature podaci:", features);

  const transformedFeatures = features.map(feature => {
    feature.geometry.coordinates = transformCoordinates(feature.geometry.coordinates, "EPSG:4326", layerCRS);
    return feature;
  });

 // console.log("🔄 Transformisani feature podaci:", transformedFeatures);

  const xml = generateInsertXML(transformedFeatures, layerName, layerCRS);

 // console.log("📜 Generisan XML za WFS insert:");
 // console.log(xml);

  try {
   // console.log("📡 Slanje WFS zahteva...");
    const response = await fetch(`${BASE_URL}/geoserver/wfs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/xml',
        'Authorization': `Bearer ${token}`
      },
      body: xml
    });

    //console.log("✅ Response Status:", response.status);

    const contentType = response.headers.get("content-type");
    if (!response.ok || !contentType.includes("xml")) {
      const errorText = await response.text();
      console.error('❌ Neočekivan odgovor od servera:', errorText);
      throw new Error(`Neočekivan odgovor od servera: ${errorText}`);
    }

    //console.log("🎉 Podaci uspešno sačuvani!");
    setIsCreated(true);
    const wfsUrl = generateWFSUrl(layerName, layerCRS);
    //console.log("🌍 Novi WFS URL:", wfsUrl);

    // Postavljanje URL-a i osvežavanje podataka
    setInputUrl(wfsUrl);
    setRefresh(true);
    setPoints([]);
    setMultiPoints([]);
    setLines([]);
    setMultiLines([]);
    setPolygons([]);
    setMultiPolygons([]);
    setPopupInfo(null);
  } catch (error) {
    console.error('❌ Greška prilikom čuvanja podataka:', error);
  }
};

// Helper function for generating WFS URL
export const generateWFSUrl = (layerName, layerCRS) => {
  const baseUrl = `${BASE_URL}/geoserver/ows`;
  const params = new URLSearchParams({
    service: 'WFS',
    version: '1.0.0',
    request: 'GetFeature',
    typeName: layerName,
    srsName: layerCRS,
    outputFormat: 'application/json',
    maxFeatures: 10000
  });

  return `${baseUrl}?${params.toString()}`;
};